// react-select's default `maxMenuHeight` is 300px; 276px is that minus the loading row's own
// padding, so the empty-input loading row occupies the same height the loaded menu will grow
// into.
.loadingRow {
  min-height: 276px;
}
